export const T = {
  en_GB: {
    title: "Identity verification",
    description: "How and when this identity was verified.",
    current: "Current",
    noLongerValid: "No longer valid",
    earlierCheck: "Earlier check",
    testMode: "Test",
    eidSigning: "eID signing",
    documentCheck: "Document check",
    verifiedSelf: "Verified: the client",
    verifiedVia: (name: string) => `Verified via ${name}`,
    empty: "No identity verification recorded.",
  },
  nb_NO: {
    title: "Identitetsverifisering",
    description: "Hvordan og når denne identiteten ble verifisert.",
    current: "Gjeldende",
    noLongerValid: "Ikke lenger gyldig",
    earlierCheck: "Tidligere kontroll",
    testMode: "Test",
    eidSigning: "eID-signering",
    documentCheck: "Dokumentkontroll",
    verifiedSelf: "Verifisert: kunden",
    verifiedVia: (name: string) => `Verifisert via ${name}`,
    empty: "Ingen identitetsverifisering registrert.",
  },
} as const;
